import { EvChRT, EvChRTV2, AHEvChRT } from 'ngx-core-services';

export type InteractiveSessions = InteractiveSession[];

export interface InteractiveSession {
  id: string;  // TID
  deep: number;  // How many days we've searched forward/backward
  isFinish: boolean;  // Whether the session search is complete
  isStartToday?: boolean;  // Whether the session starts in the current day
}

// Union type for all supported EVCharge data formats
type EvChargeDataUnion = EvChRT | EvChRTV2 | AHEvChRT;

/**
 * Initialize interactive sessions from raw EVCharge data
 * Each unique TID becomes an interactive session to track
 */
export const initializeSessions = (data: EvChargeDataUnion[]): InteractiveSessions => {
  const sessions: InteractiveSessions = [];
  data.forEach((item) => {
    const id = item.TID;
    const isPresent = sessions.find((session) => session.id === id);
    if (!isPresent) {
      sessions.push({
        id,
        deep: 0,
        isFinish: false,
      });
    }
  });
  return sessions;
};

/**
 * Check if any sessions are still incomplete (need more data)
 */
export const hasIncompleteSessions = (sessions: InteractiveSessions): boolean => {
  return sessions.some(({ isFinish }) => isFinish === false);
};

/**
 * Get sessions that need more interaction (not finished and within search limit)
 */
export const getSessionsNeedingInteraction = (
  sessions: InteractiveSessions, 
  maxDeepSearch: number
): InteractiveSession[] => {
  return sessions.filter(session => 
    !session.isFinish && session.deep < maxDeepSearch
  );
};